import { ROUTE_NAME } from '@constants';

const clubIntroduction = {
  path: '/club-introduction',
  redirect: '/club-introduction/introduction',
  meta: {
    // isDesktop: false,
    breadcrumb: true,
    breadcrumbName: '클럽소개',
    navMenu: true,
    description: '고객 여러분을 위해 보다 나은 서비스를 제공하겠습니다.',
  },
  name: ROUTE_NAME.Introduction,
  children: [
    {
      name: ROUTE_NAME.Introduction,
      path: 'introduction',
      component: () => import('@views/club-introduction/Introduction.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '클럽소개',
      },
    },
  ],
};

export default clubIntroduction;
